export default "__VITE_PUBLIC_ASSET__5a35c427__"